export const getArialabel = (label) => {
    return `${label} (opent in een nieuwe tab)`;
}
